import { render, staticRenderFns } from "./upgradeManage.vue?vue&type=template&id=2fc2abb6"
import script from "./upgradeManage.vue?vue&type=script&lang=js"
export * from "./upgradeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports